import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueWechatTitle from "vue-wechat-title";

import Tabs from "ant-design-vue/lib/tabs"; // 加载 JS
import "ant-design-vue/lib/tabs/style/css"; // 加载 CSS
import checkbox from "ant-design-vue/lib/checkbox"; // 加载 JS
import "ant-design-vue/lib/checkbox/style/css"; // 加载 CSS
import "./assets/scss/index.scss";
Vue.config.productionTip = false;
Vue.use(VueWechatTitle);
Vue.use(Tabs);
Vue.use(checkbox);
import { SExtraFilter } from "../stempcore/src/core/sextra";
Vue.use(SExtraFilter);
import { browerType } from "./common/sbase";
Vue.mixin({
  methods: {
    pxOrVw(value) {
      let newValue;
      if (browerType == "mobile") {
        if (value > 2) {
          newValue = value / 7.5 + "vw";
        } else {
          newValue = "1px";
        }
      } else {
        newValue = value + "px";
      }
      return newValue;
    }
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
